<template>
  <div>
    <Row :gutter="16">
      <Col span="8">
        <Select :value="value.name" @on-change="onInput({ name: $event, op: '', value: '' })">
          <Option v-for="item in vars" :value="item.name" :key="item.name">{{
            item.name
          }}</Option>
        </Select>
      </Col>
      <Col span="6">
        <Select
          :value="value.op"
          @on-change="onInput({ ...value, op: $event })"
          v-if="value.name"
        >
          <Option
            v-for="item in curOperator"
            :value="item.value"
            :key="item.value"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Col>
      <Col span="8">
        <Input
          v-if="value.name"
          :value="value.value"
          @on-change="onInput({ ...value, value: $event.target.value })"
        />
      </Col>
      <Col span="2">
        <Icon
          class="var-del-icon"
          color="#ed4014"
          type="ios-trash-outline"
          @click="$emit('delete')"
        />
      </Col>
    </Row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        name: '',
        op: '',
        value: '',
      }),
    },
  },
  data() {
    return {
      type: {
        NUM: ['+', '-', '*', '/', '='],
        STR: ['=', '+'],
      },
    };
  },
  computed: {
    ...mapState('setting', ['vars']),
    curVal() {
      return this.vars.find((item) => item.name === this.value.name) || {};
    },
    // operator选项
    curOperator() {
      const type = this.curVal.type;
      if (!type) return [];
      return this.type[type]?.map((item) => ({
        label: item,
        value: item,
      }));
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    }
  }
};
</script>